/**
 * TwinDeriveView (P144.2) -- the twin chain-deriver console. Triggers +
 * watches the 4 chain derivers (blast / resilience / process / obligation)
 * via the shared engine_batch_runs substrate. The derivers are fast (pure
 * DB seals, no LLM) so the cards show a spinner + result counts rather than
 * a per-item progress bar. Additive to the scheduler + the sync /derive/*
 * endpoints.
 */
import { EngineBatchRunsPanel } from "shared/admin/EngineBatchRunsPanel";
import { useTranslation } from "react-i18next";

const KINDS = [
  {
    kind: "derive_blast",
    name: "Blast radius",
    desc: "Re-seal every depended-upon entity's downstream blast graph (vendors / services / IBSes).",
  },
  {
    kind: "derive_resilience",
    name: "Resilience state",
    desc: "Re-derive RAG resilience per entity from open findings + dependency propagation.",
  },
  {
    kind: "derive_process",
    name: "Process coverage",
    desc: "Re-seal process coverage from the customer journeys traversing each entity.",
  },
  {
    kind: "derive_obligation",
    name: "Obligation set",
    desc: "Re-narrow + re-seal the per-entity regulatory obligation set. Run after a summarise / tag pass.",
  },
];

const _BASE = "/v1/admin/twin/derive-batch";

export function TwinDeriveView() {
  const { t } = useTranslation();
  return (
    <EngineBatchRunsPanel
      testid="twin-derive-view"
      rubric="Admin · Operational Twin"
      heading={t("screens.twinDeriveView.chainDerivers")}
      intro="Trigger the twin chain derivers and watch them complete in app. These also run automatically on the scheduler; this is the manual, watchable trigger."
      notAdminMessage="The twin derive console is admin-only."
      kinds={KINDS}
      listPath={`${_BASE}/runs`}
      triggerPath={(kind) => `${_BASE}/${kind}`}
    />
  );
}
